import { useQuery } from '@tanstack/react-query'

import { apiGetSealedOrderDetail } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * 가장 최근 밀봉비닐 주문 상세 조회.
 * null 응답(활성 주문 없음) 도 정상 결과로 취급.
 */
export const useGetSealedOrderDetail = () =>
  useQuery({
    queryKey: [PAYMENT_KEYS.SEALED_ORDER_DETAIL],
    queryFn: apiGetSealedOrderDetail,
    staleTime: 0,
  })
